/** S3-managed app config path at the UI bucket root. */
export const APP_CONFIG_PATH = '/app-config/config.json';
